"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var dlsConfig = {
  backgroundSize: {
    small: '24px',
    medium: '32px',
    large: '40px'
  },
  backgroundShape: {
    square: '0%',
    'rounded-rect': '20%',
    circle: '50%'
  },
  iconSize: {
    small: '16px',
    large: '24px'
  }
};
var _default = dlsConfig;
exports.default = _default;